module.exports = "pegasus/assets/circle-facebook.gif";